export const Modulecreator = {
    state: {},
    mutations: {},
    getters: {
        isModulecreatorActive(state, getters, rootState) {
            if (rootState.route.query.modulecreator) {
                return true;
            }
            return false;
        },
        getModulecreatorInsertAfter(state, getters, rootState) {
            if (rootState.route.query.modulecreator_insertafter) {
                return rootState.route.query.modulecreator_insertafter;
            }
            return null;
        }
    },
    actions: {
        async openModulecreator(context, payload = null) {
            let args = {
                modulecreator: 1
            };
            if (payload !== null) {
                args['modulecreator_insertafter'] = payload;
            }
            await context.dispatch('routeAddQuery', args);
        },
        async closeModulecreator(context) {
            await context.dispatch('routeRemoveQuery', [
                'modulecreator',
                'modulecreator_insertafter'
            ]);
        }
    }
};
